/* @flow */
import { Set, Record } from 'immutable';

export type RawOptions = {
  query?: string,
  pageNumber?: number,
  pageSize?: number,
  sortBy?: string,
  sortOrder?: 'ASC' | 'DESC',
};

export const Options = Record({
  query: '',
  pageNumber: 0,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'DESC',
});

export type RawMalwareType = {
  guid: string,
  name: string,
  aliases: Set<string>,
  created: number,
  createdBy: string,
  updated: number,
  updatedBy: string,
};

export type MalwareRecordType = Record<RawMalwareType>;

export const Malware = Record({
  guid: '',
  name: '',
  aliases: Set(),
  created: null,
  createdBy: '',
  updated: null,
  updatedBy: '',
});

// Like payload action but also supports field to update
export type MalwareAction<T> = {
  type: string,
  payload: T,
  field?: string,
  error?: boolean,
  meta?: Object,
};



// WEBPACK FOOTER //
// ./src/app/modules/malware/types.js